import bookingService from "@/apis/booking";
import cuotomerService from "@/apis/customer";
import getUserInfo from "@/models/userInfo";

export default {
  data() {
    return {
      allEnum: {},
      hisEnum: {},
      currentUserInfo: {},
    };
  },
  async created() {
    this.getAllEnum();
    this.getHisEnum();
    this.$store.dispatch("customer/setCustomerInfo", {});
    // await this.getWorkDingAuth();
    const userInfo = await getUserInfo();
    this.currentUserInfo = userInfo;
  },
  methods: {
    desensitization(str, beginLen, endLen) {
      var len = str.length;
      if (beginLen - endLen >= len) {
        return str;
      }
      var firstStr = str.substr(0, beginLen);
      var lastStr = str.substr(endLen);
      var middleStr = str
        .substring(beginLen, len - Math.abs(endLen))
        .replace(/[\s\S]/gi, "*");
      const tempStr = firstStr + middleStr + lastStr;
      return tempStr;
    },
    getAllEnum() {
      bookingService.bookEnums().then((res) => {
        this.allEnum = res;
      });
    },
    getHisEnum() {
      cuotomerService.hisPatientEnums().then((res) => {
        this.hisEnum = res;
      });
    },
  },
};
